import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ClientPortal from "@/pages/ClientPortal";
import AdminReviews from "@/pages/AdminReviews";

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#151F32",
            color: "#F8FAFC",
            border: "1px solid rgba(255,107,0,0.3)",
            fontFamily: "'Manrope', sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portal" element={<ClientPortal />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
